module.exports = __webpack_public_path__ + "img/readon.4b2956c4.png";